import {resolveBackground} from '#core/utils/color-utils.js';

export function staticPagesFactory(PALETTE) {
    return {
        StaticHtmlPage: {
            container: {
                ...resolveBackground(PALETTE.STATIC_PAGE_BG),
            },
            textView: {
                header: {
                    textStyle: {
                        ...PALETTE.STATIC_PAGE_HEADER_TEXT,
                    },
                    borderStyle: {
                        borderColor: PALETTE.STATIC_PAGE_SEPARATOR_COLOR,
                    },
                },
                textArea: {
                    textStyle: {
                        ...PALETTE.STATIC_PAGE_TEXT,
                    },
                },
            },
        },
    };
}
